import { IRes } from "api/types";
import { apiInstance } from "api/instance";

import { ENDPOINTS } from "api/constants";
import { CheckConfirmationCodeReq, type SendConfirmationCodeReq } from "./req";
import { notify } from "utils";

export const sendConfirmationCodeApi = (
  body: SendConfirmationCodeReq
): Promise<{ UserID: number }> => {
  return apiInstance
    .post<IRes<{ UserID: number }[]>>(ENDPOINTS.SEND_CONFIRMATION_CODE, body)
    .then((response) => response.data)
    .then(
      (response) => {
        if (response.successful) {
          return Promise.resolve(response.result[0]);
        }
        notify({
          type: "error",
          message: response.resultMessage as string,
        });
        throw new Error(response.resultMessage);
      },
      (error) => {
        const errorBody = error?.response?.data;
        notify({
          type: "error",
          message: errorBody,
        });
        // as ErrorMessage;
        // return Promise.reject(errorTranslator(errorBody));
        return Promise.reject(errorBody);
      }
    )
    .catch((error) => {
      return Promise.reject(error);
    });
};
export const checkConfirmationCodeApi = (
  body: CheckConfirmationCodeReq
): Promise<string> => {
  return apiInstance
    .post<IRes<string>>(ENDPOINTS.CHECK_CONFIRMATION_CODE, body)
    .then((response) => response.data)
    .then(
      (response) => {
        if (response.successful) {
          return Promise.resolve(response.result);
        }
        notify({
          type: "error",
          message: response.resultMessage as string,
        });
        throw new Error(response.resultMessage);
      },
      (error) => {
        const errorBody = error?.response?.data;
        notify({
          type: "error",
          message: errorBody,
        });
        // as ErrorMessage;
        // return Promise.reject(errorTranslator(errorBody));
        return Promise.reject(errorBody);
      }
    )
    .catch((error) => {
      return Promise.reject(error);
    });
};

export {};
